import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Users, CheckCircle2, ChevronRight, X } from 'lucide-react';

const STEPS = [
  {
    icon: FileText,
    label: 'Create a work order',
    desc: 'Define your site, service type, and schedule recurring shifts in minutes.',
    cta: true,
  },
  {
    icon: Users,
    label: 'We help you connect',
    desc: 'We try to connect you with, and find, the best possible match for your request. For emergencies, please call 911.',
    cta: false,
  },
  {
    icon: CheckCircle2,
    label: 'Track in real time',
    desc: 'Monitor officers, approve rates, and pull shift reports — all in one place.',
    cta: false,
  },
];

const HowItWorks = ({ onWorkOrder, onDismiss }) => (
  <motion.div
    initial={{ opacity: 0, y: -8 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, height: 0 }}
    className="relative rounded-xl border border-[#CC457D]/10 bg-[#CC457D]/[0.03] px-4 py-4"
  >
    {/* dismiss — commented out, strip is permanent
    <button
      onClick={onDismiss}
      className="absolute right-3 top-3 text-muted-foreground transition-colors hover:text-foreground"
    >
      <X size={13} />
    </button>
    */}

    <p className="mb-4 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
      How it works
    </p>

    {/* Steps — absolute connector line sits at the circle center (step label 16px + gap 4px + half of h-8 = 16px → top-9) */}
    <div className="relative">
      {/* The connecting line — top-4 = half of h-8 circle */}
      <div className="absolute top-4 left-4 right-4 border-t border-dashed border-gray-200" />

      <div className="relative grid grid-cols-3 gap-6">
        {STEPS.map(({ icon: Icon, label, desc, cta }, i) => (
          <div key={i} className="flex flex-col items-start">
            {/* circle */}
            <div className="mb-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#404880] text-white shadow-sm ring-4 ring-[#fdf2f6]">
              <Icon size={14} />
            </div>

            <p className="text-xs font-semibold text-card-foreground">
              <span className="mr-1 text-[#404880]/50">({i + 1})</span>
              {label}
            </p>
            <p className="mt-0.5 text-[11px] leading-relaxed text-muted-foreground">{desc}</p>

            {cta && (
              <button
                onClick={onWorkOrder}
                className="mt-3 flex items-center gap-1 rounded-md bg-[#CC457D] px-3 py-1.5 text-[11px] font-medium text-white transition-colors hover:bg-[#CC457D]/90"
              >
                + New Work Order
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  </motion.div>
);

export default HowItWorks;
